export enum AssembleiaStatus {
  NaoDisponivel,
  Pre,
  Live,
  Pos,
  Encerrado,
}

export enum AssembleiaStatusDescription {
  NAO_DISPONIVEL = "NAO_DISPONIVEL",
  PRE_ASSEMBLEIA = "PRE_ASSEMBLEIA",
  ASSEMBLEIA = "ASSEMBLEIA",
  POS_ASSEMBLEIA = "POS_ASSEMBLEIA",
  ENCERRADO = "ENCERRADO",
}
